export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8578.602a28a8.jpg";